<template>
  <div>
    <div v-for="question of questions" :key="question.questionId" class="poll-question">
      <!-- we put the keep-alive component in order to use
      the beforeRouteLeave() lifecycle hook inside QuestionContent-->
      <keep-alive>
        <question-list-entry
          :question="question"
          :userHasVoted="userHasVoted(poll.pollId, question.questionId, userVotes)"
          @questionClicked="$emit('questionSelected', question.questionId)"
        ></question-list-entry>
      </keep-alive>
    </div>
    <user-score v-if="poll.isAsync && votedAll"></user-score>
  </div>
</template>

<script>
import QuestionListEntry from '@/components/questions/QuestionListEntry';
import { mapActions, mapGetters } from 'vuex';
import UserScore from '../../components/questions/UserScore.vue';

export default {
  name: 'question-list',
  components: {
    QuestionListEntry,
    UserScore
  },
  props: {
    poll: Object,
    questions: Array,
    user: Object,
    userVotes: Object
  },
  computed: {
    ...mapGetters({ votedAll: 'userHasVotedAll' })
  },
  mounted() {
    this.fetchStatsOfPoll({ pollId: this.poll.pollId });
  },
  methods: {
    ...mapActions(['fetchStatsOfPoll']),
    userHasVoted(pollId, questionId, userVotes) {
      return (userVotes[pollId] || []).includes(questionId);
    }
  }
};
</script>

<style lang="scss" scoped>
.instruction {
  margin: 20px 0;
}
</style>
